module.exports = __webpack_public_path__ + "img/marker_two_yellow1.e72d15e9.png";